var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.links && _vm.links.length
    ? _c(
        "form",
        { ref: "form", attrs: { action: _vm.formAction, method: "get" } },
        [
          _c("div", { staticClass: "dropdown-links" }, [
            _c("button", { class: _vm.inputClass }, [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.dropdownLabel) },
              }),
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedPageIndex,
                    expression: "selectedPageIndex",
                  },
                ],
                staticClass: "dropdown-links__input",
                attrs: { name: "ref" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedPageIndex = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", {
                  attrs: { value: "" },
                  domProps: { innerHTML: _vm._s(_vm.instructions) },
                }),
                _vm._v(" "),
                _vm._l(_vm.links, function (link, index) {
                  return _c("option", {
                    key: "option-" + index,
                    domProps: { value: index, innerHTML: _vm._s(link.label) },
                  })
                }),
              ],
              2
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/DropdownLinks.vue